import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { ALMACEN_GESTION_ENTREGAS } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function AlmacenGestionPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ALMACEN_GESTION_ENTREGAS}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
